<template>
  <div>

    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.2
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

  <div class="seventhreecss">
    <div class="seven3css">
    <SeventyThirtysection :LeftsideText="auditdetailtoptext" :RightsideText="audithighlights" leftsectheme="leftseccss"/>
    </div>

  

    <div class="tbAcss">{{tbAtopcaption}}</div>
    <div class="accordionformat">
        <div class="accordion accordion-flush" id="accordionFlushExample">
          <div class="accordion-item">
            <h2 class="accordion-header " id="flush-headingOne">
              <button class="accordion-button acheader1 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                <span>{{ tbAsecAcaption }}</span>
              </button>
            </h2>
            <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <div v-html="tbAsecAdetails"></div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header " id="flush-headingTwo">
              <button class="accordion-button  acheader2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                <span>{{ tbAsecBcaption }}</span>
              </button>
            </h2>
            <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <div v-html="tbAsecBdetails"></div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header " id="flush-headingThree">
              <button class="accordion-button acheader3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                <span>{{ tbAsecCcaption }}</span>
              </button>
            </h2>
            <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">
                <div v-html="tbAsecCdetails"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
      
  <section class="accordioncssformat">
  <div class="sectionBFormat">
    <div v-html="auditdetailbtmtext"></div>
    <div class="tbAcss">{{tbBtopcaption}}</div>
      <div class="accordion accordion-flush" id="accordionFlushSectionB">
        <div class="accordion-item">
          <h2 class="accordion-header " id="flush-headingB1">
            <button class="accordion-button acheader1 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseB1" aria-expanded="false" aria-controls="flush-collapseB1">
              <span>{{ tbBsecAcaption }}</span>
            </button>
          </h2>
          <div id="flush-collapseB1" class="accordion-collapse collapse" aria-labelledby="flush-headingB1" data-bs-parent="#accordionFlushSectionB">
            <div class="accordion-body">
              <div v-html="tbBsecAdetails"></div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header " id="flush-headingB2">
            <button class="accordion-button acheader2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseB2" aria-expanded="false" aria-controls="flush-collapseB2">
              <span>{{ tbBsecBcaption }}</span>
            </button>
          </h2>
          <div id="flush-collapseB2" class="accordion-collapse collapse" aria-labelledby="flush-headingB2" data-bs-parent="#accordionFlushSectionB">
            <div class="accordion-body">
              <div v-html="tbBsecBdetails"></div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header " id="flush-headingB3">
            <button class="accordion-button acheader3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseB3" aria-expanded="false" aria-controls="flush-collapseB3">
              <span>{{ tbBsecCcaption }}</span>
            </button>
          </h2>
          <div id="flush-collapseB3" class="accordion-collapse collapse" aria-labelledby="flush-headingB3" data-bs-parent="#accordionFlushSectionB">
            <div class="accordion-body">
              <div v-html="tbBsecCdetails"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
  </section>

  <section class="bottomtext">
    <div class=" bottomtext col-xs-12 col-sm-12">
      <hr />
      <p  v-html="auditbottompage">
      </p>
    </div>
  </section>


</div>
</template>

<script>

import IntFrame from '@/components/IntFrame.vue';
import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/globalDeclare.js');
require('@/assets/css/video-js.css');
import axios from 'axios';


export default {
name: 'AboutView',
components: {
IntFrame,SeventyThirtysection, BreadCrumbs
},
data() {
return {
videoimage: [],
imagetext: '',
src: '',
playrate: '',
poster: '',
// pvwebm: '',
// pvmp4: '',
pvstyle: '',
pvsrc: '',
pvisvideo: false,
pvpanorama1: '',
pvpanorama2: '',
pvpanorama3: '',
pvhotspot1: '',
pvhotspot2: '',
pvhotspot3: '',
showVideo: false,
showPanorama: false,

auditdetailtoptext: '',
audithighlights: '',
auditdetailbtmtext: '',
auditbottompage: '',
tbAtopcaption: '',
tbAsecAcaption: '',
tbAsecAdetails: '',
tbAsecBcaption: '',
tbAsecBdetails: '',
tbAsecCcaption: '',
tbAsecCdetails: '',

tbBtopcaption: '',
tbBsecAcaption: '',
tbBsecAdetails: '',
tbBsecBcaption: '',
tbBsecBdetails: '',
tbBsecCcaption: '',
tbBsecCdetails: '',

breadcrumbsinfo: [],

height: 0,
width: 0,
}
},
methods: {

},

async mounted() {
this.myPicUrl = myUrlPath

axios.get('allpagespv/audits').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })

//------------all highlights---------------
await axios.get('getallhiglights/audits').then(
  response => {
      this.audithighlights = response.data[0].highlightdesc
})
.catch((error) => {
    console.log(error)
  })


//-----------All invest page report data--------------
await axios.get('getinvestinfo/').then(
  response => {
      this.investallinfo = response.data
      this.auditdetailtoptext = response.data[0].auditdetailtoptext
      this.auditdetailbtmtext = response.data[0].auditdetailbtmtext
      this.auditbottompage = response.data[0].auditbottompage
     
  })
.catch((error) => {
    console.log(error)
  })

//------------breadcrumbs mappings info---------------
await axios.get('getbreadcrumbsinfo/audits').then(
response => {
    this.breadcrumbsinfo = response.data
  })
  .catch((error) => {
      console.log(error)
      })

      //------------breadcrumbs mappings info---------------
await axios.get('getauditdetailsinfo/').then(
response => {
  this.tbAtopcaption = response.data[0].tbAtopcaption
  this.tbAsecAcaption = response.data[0].tbAsecAcaption
  this.tbAsecAdetails = response.data[0].tbAsecAdetails 
  this.tbAsecBcaption = response.data[0].tbAsecBcaption
  this.tbAsecBdetails = response.data[0].tbAsecBdetails
  this.tbAsecCcaption = response.data[0].tbAsecCcaption
  this.tbAsecCdetails = response.data[0].tbAsecCdetails

  this.tbBtopcaption = response.data[0].tbBtopcaption
  this.tbBsecAcaption = response.data[0].tbBsecAcaption
  this.tbBsecAdetails = response.data[0].tbBsecAdetails
  this.tbBsecBcaption = response.data[0].tbBsecBcaption
  this.tbBsecBdetails = response.data[0].tbBsecBdetails
  this.tbBsecCcaption = response.data[0].tbBsecCcaption
  this.tbBsecCdetails = response.data[0].tbBsecCdetails
  })
  .catch((error) => {
      console.log(error)
      })
}
}
</script>

<style scoped>

.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.formatsections {
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 100px;
}

.breadcrumcss {
margin-top: 180px;
padding-left: 100px;
margin-bottom: -100px;
}
.bottomtext {
  text-align: justify;

  padding: 100px;
}

.tbAcss {
  padding-left: 100px;
}
.accordionformat, .sectionBFormat {
  padding-left: 100px;
  padding-right: 400px;

  padding-bottom: 100px;
}
.accordioncssformat {
  background-color: #003; 
  padding-top: 100px;
  padding-bottom: 100px;
  color: rgb(201, 198, 198);
  font-size: 18px;
}
.acheader1, .acheader3 {
  border-top: thin solid orangered;
  border-bottom: thin solid orangered;
  background-color: rgb(226, 225, 225);
}

.acheader1, .acheader2, .acheader3 {
  font-weight: bold;
  color: #003;
  font-size: 20px;
}
.seven3css {
  margin-top: 250px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {


}


/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {


/*@-moz-document url-prefix() {
 
}*/
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
 
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .seventhreecss {
    padding-left: 100px;
    padding-right: 100px;
  }
} 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

} 


</style>
